import ChangePassword from '@/views/profile/change-password'
import VueQrcode from '@xkeshi/vue-qrcode'
export default {
  name: 'show',
  components: {
    ChangePassword,
    'qrcode': VueQrcode
  },
  props: [],
  data () {
    return {
    }
  },
  computed: {
    profile () {
      return this.$store.getters['Profile/getProfile']
    },
    qr_code () {
      let code = {}
      code.URL_API = process.env.URL_API
      code.APP_NAME = 'Petrolimex Aviation'
      // code.fullname = this.profile.fullname
      // code.email = this.profile.email
      // code.avatar = this.profile.avatar500x500
      return code
    }
  },
  mounted () {
    this.$loading.start()
    this.$store.dispatch('Profile/getProfile').then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.complete()
    })
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/views/profile/show/show.js